import { Expose } from "class-transformer";

import { BaseModel } from "src/shared/models/base.model";

export class PushSubscriptionRequest extends BaseModel {
    @Expose() applicationToken = "";
    @Expose() deviceCode = "";
    @Expose() brand = "";
    @Expose() model = "";
    @Expose() enabled = false;
}
